<template>
  <div class="stepper" :style="{ backgroundColor: progressBackgroundColor }">
    <div :style="getProgressStyle" class="progress"></div>
  </div>
</template>

<script>
import Colors from '../scss/riseup-js-colors.module.scss';

export const StepperProps = {
  currentStep: {
    type: Number,
    required: true,
  },
  totalSteps: {
    type: Number,
    required: true,
  },
  progressColor: {
    type: String,
    default: Colors.riseupBlue,
  },
  progressBackgroundColor: {
    type: String,
    default: Colors.riseupGray0,
  },
};
export default {
  name: 'StepperV2',
  props: StepperProps,
  computed: {
    getProgressStyle() {
      const width = `${(Math.min(this.currentStep, this.totalSteps) / this.totalSteps) * 100}%`;
      return {
        width,
        backgroundColor: this.progressColor,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/riseup-colors';
@import '../scss/spacings';
@import '../scss/border-radius';

$stepper-height: 6px;

.stepper {
  width: 100%;
  height: $stepper-height;
  border-radius: $ri-border-radius-small;
}

.progress {
  height: 100%;
  transition: width 0.3s;
  border-radius: $ri-border-radius-small;
}
</style>
